import {RouteDefinition} from '../../../routes';
import {SoundEditScreen} from './SoundEditScreen';

export const SoundSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/sound',
        component: SoundEditScreen,
    },
];
